import { useMemo, useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import JobApplyForm from 'hb-react/frontoffice/apps/JobsV2/components/JobApplyForm';
import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import { openLoginModal } from 'hb-react/shared/utils/login/openLoginModal';

const Actions = () => {
  const { currentUser } = useDefaultAppContexts();
  const {
    id: jobId,
    title: jobTitle,
    apply_by: applyBy,
    current_user_can_apply: currentUserCanApply,
    email,
    expired,
    jobKindConfig,
    url,
    hasCurrentUserAlreadyApplied,
  } = useJobContext();

  const [showApplyModal, setShowApplyModal] = useState(false);

  const onCloseApplyModal = () => setShowApplyModal(false);

  const nativeFieldsActivated = jobKindConfig?.fields || {};

  const showApply = useMemo(() => {
    if (
      expired ||
      !currentUserCanApply ||
      !nativeFieldsActivated.apply_button ||
      !applyBy ||
      hasCurrentUserAlreadyApplied
    ) {
      return false;
    }

    if (applyBy === 'external_link' && url) {
      return true;
    }

    if (applyBy === 'contact_email' && email) {
      return true;
    }

    return false;
  }, [
    applyBy,
    currentUserCanApply,
    email,
    expired,
    nativeFieldsActivated.apply_button,
    url,
    hasCurrentUserAlreadyApplied,
  ]);

  const onApply = useMemo(() => {
    if (applyBy === 'external_link') {
      return () => window.open(url, '_blank', 'noopener', 'noreferrer');
    }

    if (applyBy === 'contact_email') {
      return () => setShowApplyModal(true);
    }
  }, [applyBy, url]);

  // Temporary.
  // Remove once the 'Save opportunity' button gets implemented
  if (!showApply) {
    return null;
  }

  return (
    <>
      <Box mt={4}>
        {showApply &&
          (currentUser ? (
            <Button onClick={onApply}>{s__('JobsV2|Apply now')}</Button>
          ) : (
            <Button onClick={() => openLoginModal()}>
              {s__('JobsV2|Login to apply')}
            </Button>
          ))}
        {/* <Button ml={3} variant="secondary">
        {s__('JobsV2|Save opportunity')}
      </Button> */}
      </Box>
      {showApplyModal && (
        <ModalWithTemplate
          onCloseModal={onCloseApplyModal}
          header={s__('JobsV2|Apply to %{opportunityName}').i__({
            opportunityName: jobTitle,
          })}
          width="large"
        >
          <JobApplyForm jobId={jobId} onClose={onCloseApplyModal} />
        </ModalWithTemplate>
      )}
    </>
  );
};
export default Actions;
